import React from "react"
import "./patientCardView.scss"
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Avatar from '@mui/material/Avatar';
import LocalHospitalOutlinedIcon from '@mui/icons-material/LocalHospitalOutlined';
import { makeStyles, createStyles } from '@material-ui/core/styles'
import PaymentIcon from '@mui/icons-material/Payment';
import Tooltip from '@mui/material/Tooltip';
import BiotechOutlinedIcon from '@mui/icons-material/BiotechOutlined';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import EmailIcon from '@mui/icons-material/Email';
import { useNavigate } from "react-router-dom";
import HotelIcon from '@mui/icons-material/Hotel';
import Typography from '@mui/material/Typography';
import useIPDHook from "../../pages/Ipd/ipdHooks";


function stringAvatar(name) {


    const childrenName = name && name?.indexOf(' ') === -1
        ? `${name?.length > 0 && name?.split(' ')[0][0]}` : `${name?.length > 0 && name?.split(' ')[0][0]}${name?.length > 0 && name?.split(' ')[1][0]}`
    return {
        sx: {
            bgcolor: stringToColor(name),
        },
        children: childrenName,
    };
}


function stringToColor(string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string?.length; i += 1) {
        hash = string?.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
}
const drawerWidth = 240

const useStyles = makeStyles(theme =>
    createStyles({
        appMenu: {
            width: '100%',
        },
        navList: {
            width: drawerWidth,
        },
        menuItem: {
            width: drawerWidth,
        },
        menuItemIcon: {
            color: '#97c05c',
        },
    }),
)


const PatientCardView = (props) => {
    const navigate = useNavigate();
    const { handleIPDRoute } = useIPDHook()
    const { patientList, loading, handleIndividualPatientClick, handleOpdCardClick } = props;
    const classes = useStyles()
    const [open, setOpen] = React.useState(loading ? loading : false);
    const handleClose = () => {
        setOpen(false);
    };


    const BackDropLoader = () => (
        <div>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}
                onClick={handleClose}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>

    )
    const handlePayment = (event, patientInfo) => {
        event.stopPropagation()
        navigate("/patient-recieve-fee", { state: { rowData: patientInfo, patientID: patientInfo?.uniqueID } })

    }

    const handlePathology = (event, patientInfo) => {
        event.stopPropagation()
        navigate("/pathalogy", { state: { rowData: patientInfo } })

    }



    return (
        <div className="patient-card-view">
            {loading ? BackDropLoader() : patientList.map((pname, index) => {
                return (
                    <div className="col-md-3 mt-2 patient-view" onClick={(e) => handleIndividualPatientClick(e, pname)} key={index}>
                        <div className="card text-center">
                            <div className="img mb-2 d-flex justify-content-center mt-2">
                                <Avatar {...stringAvatar(pname?.name)} />
                            </div>
                            <div className="dcard-cont">
                                <h5 className="mb-0 doc-name">{pname?.name.length > 0 ? pname?.name : "No Data"}</h5>
                                <div className="ratings">
                                    <p className="emr-number">#{pname?.emrNumber}</p>
                                </div>
                                <div className="location">
                                    <div className="footer-details d-flex justify-content-left  pl-2 pr-2">
                                        <div className="location-icon">
                                            <LocationOnIcon />
                                        </div>
                                        <div>
                                            <Typography className="address">{pname?.address}</Typography>
                                        </div>
                                    </div>
                                </div>
                                <div className="email-details d-flex pl-2">
                                    <div className="email-ic text-center">
                                        <EmailIcon className="email-icon" />
                                    </div>
                                    <div className="email">
                                        <Typography className="email ml-2">{pname?.email}</Typography>
                                    </div>

                                </div>
                            </div>
                            <div className="speclist-part d-flex justify-content-around">
                                <div className="spec">
                                    <Tooltip title="Opd">
                                        <LocalHospitalOutlinedIcon className={classes.menuItemIcon}
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                handleOpdCardClick(e, pname)
                                            }
                                            } />
                                    </Tooltip>
                                </div>
                                <div className="spec">
                                    <Tooltip title="Ipd">
                                        <HotelIcon className={classes.menuItemIcon}
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                handleIPDRoute(pname)
                                            }
                                            }
                                        />
                                    </Tooltip>
                                </div>
                                <div className="spec">
                                    <Tooltip title="Payment">
                                        <PaymentIcon className={classes.menuItemIcon} onClick={(e) => handlePayment(e, pname)} />
                                    </Tooltip>

                                </div>
                                <div className="spec">
                                    <Tooltip title="Pathology">
                                        <BiotechOutlinedIcon className={classes.menuItemIcon} onClick={(e) => handlePathology(e, pname)} />
                                    </Tooltip>
                                </div>
                            </div>
                        </div>

                    </div>
                )
            })}
        </div>

    )
};

export default PatientCardView;